import React, { useEffect, useState } from "react";
import { Gift, Copy, Check, Truck } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export function PromoBanner() {
  const [cfg, setCfg] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { api.get("/settings/home-banner").then((r) => setCfg(r.data)).catch(console.error); }, []);
  if (!cfg || !cfg.enabled || !cfg.code_valid) return null;
  const copy = () => {
    Promise.resolve(navigator.clipboard?.writeText(cfg.code)).then(() => {
      setCopied(true); toast.success(`Code ${cfg.code} copié — colle-le dans Options au moment de payer`);
      setTimeout(() => setCopied(false), 2500);
    }).catch(console.error);
  };
  return (
    <div data-testid="home-promo-banner" className="relative overflow-hidden bg-neon-green text-black border-b-4 border-neon-magenta">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: "repeating-linear-gradient(135deg, #000 0 12px, transparent 12px 24px)" }} />
      <div className="relative max-w-6xl mx-auto px-4 py-3 sm:py-3.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-5 text-center sm:text-left">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center justify-center h-9 w-9 bg-black text-neon-green rounded-full shrink-0 animate-flicker"><Gift className="h-5 w-5" /></span>
          <p className="font-anton uppercase text-base sm:text-lg leading-tight" data-testid="home-promo-text">
            <Truck className="inline h-4 w-4 mr-1 -mt-0.5" />{cfg.text}
          </p>
        </div>
        <button type="button" data-testid="home-promo-copy" onClick={copy}
          className="min-h-[44px] inline-flex items-center gap-2 bg-black text-white px-4 py-2 font-anton uppercase tracking-[0.15em] hover:bg-neon-magenta transition-colors shadow-[0_0_18px_rgba(228,20,196,0.45)]">
          {copied ? <Check className="h-4 w-4 text-neon-green" /> : <Copy className="h-4 w-4" />}
          <span data-testid="home-promo-code">{cfg.code}</span>
          <span className="text-[11px] font-outfit tracking-normal normal-case text-zinc-300 hidden sm:inline">· {cfg.cta}</span>
        </button>
      </div>
    </div>
  );
}
